import { useFromInput } from '@ui/features/Trade/hooks/useFromInput';
import { useLeverage } from '@ui/features/Trade/store/useLeverage';
import { useTradingPair } from '@ui/features/Trade/store/useTradingPair';
import { ZERO_BIG_NUMBER } from '@ui/lib/bignumber';
import { getClosePositionFee } from '@ui/utils/trade/getClosePositionFee';
import { isNil } from 'lodash-es';
import { useMemo } from 'react';

import { useCollateralToken } from '../store/useCollateralToken';
import { usePositionSize } from './usePositionSize';

// only use in open position flow
export const useClosePositionFee = () => {
  const tradePairInfo = useTradingPair((s) => s.useTradingPair());
  const leverage = useLeverage();
  const closeFeeP = tradePairInfo?.feeConfig?.closeFeeP;
  const minCloseFeeP = tradePairInfo?.feeConfig?.minCloseFeeP;
  const lvTokenDiscountP = tradePairInfo?.feeConfig?.lvTokenDiscountP;
  const shareP = tradePairInfo?.feeConfig?.shareP;
  const inputUsd = useFromInput((s) => s.input).value.usd; // fromUsd
  const collateralToken = useCollateralToken(s => s.useCollateralTokenValue());
  const positionSize = usePositionSize({ inputUsd });

  return useMemo(() => {
    if (
      isNil(closeFeeP) ||
      isNil(shareP) ||
      isNil(minCloseFeeP) ||
      isNil(positionSize) ||
      isNil(leverage) ||
      isNil(inputUsd) ||
      inputUsd.isNaN()
    )
      return;

    return getClosePositionFee({
      isDegen: tradePairInfo.isDegenPair,
      closeFeeP,
      isLVTokenPay: collateralToken?.address.toLowerCase() == collateralToken?.lvTokenAddress.toLowerCase(),
      lvTokenDiscountP: lvTokenDiscountP,
      positionSize,
      pnl: ZERO_BIG_NUMBER, // for open position, this is zero
      shareP,
      minCloseFeeP,
      fundingFee: ZERO_BIG_NUMBER, // for open position, this is zero
      holdingFee: ZERO_BIG_NUMBER, // for open position, this is zero
      collateralUsd: inputUsd,
    });
  }, [
    closeFeeP,
    inputUsd,
    leverage,
    minCloseFeeP,
    lvTokenDiscountP,
    collateralToken?.address,
    positionSize,
    shareP,
    tradePairInfo.isDegenPair,
  ]);
};
